import { koraxTokens } from "../designSystem";

export const colorBack = () => {
  return koraxTokens.colors.background;
};

export const colorPrimary = () => {
  return koraxTokens.colors.primary;
};

export const colorIconesMenu = () => {
  return koraxTokens.colors.sidebar;
};

export const colorTitleTable = () => {
  return koraxTokens.colors.textSecondary;
};

export const colorTopTable = () => {
  return koraxTokens.colors.surfaceMuted;
};

export const colorBackgroundTable = () => {
  return koraxTokens.colors.surface;
};

export const colorLineTable = () => {
  return koraxTokens.colors.primary;
};

export const colorLineTableHover = () => {
  return koraxTokens.colors.primarySoft;
};

export const colorTopbar = () => {
  return koraxTokens.colors.sidebar;
};
